import { takeLatest, all, select } from 'redux-saga/effects';
import { maybeOpenInNewTab } from 'src/utils/commonUtils';
import { getIsWebview } from 'src/store/view/selectors';
import { isSSR } from 'src/helpers/ssr';
import {
  CONFIRMABILITY_PARAM_KEY,
  OPERATOR_QUERY_PARAM_KEY,
  PAYMENT_BENEFITS_QUERY_PARAM_KEY,
} from '../../../../constants/filters';
import {
  getSearcherInstantConfirm,
  getSearcherPaymentBenefitsFilter,
  selectedOperatorsArraySelector,
} from '../selectors/searcher';
import { openOfferAction } from '../actions/offer';

function* handleOfferClicked({ payload }: ReturnType<typeof openOfferAction>) {
  const { link } = payload;
  const operatorsIds = yield select(selectedOperatorsArraySelector);
  const paymentBenefitsIds = yield select(getSearcherPaymentBenefitsFilter);
  const instantConfirm = yield select(getSearcherInstantConfirm);
  const formattedPaymentBenefitsIds = paymentBenefitsIds
    .map(
      (paymentBenefitId) =>
        `${PAYMENT_BENEFITS_QUERY_PARAM_KEY}[]=${paymentBenefitId}`,
    )
    .join('&');

  const formattedTOIds = operatorsIds
    .map((operatorId) => `${OPERATOR_QUERY_PARAM_KEY}[]=${operatorId}`)
    .join('&');

  const linkWithTOFilters = formattedTOIds
    ? `${link}&${formattedTOIds}`
    : `${link}`;
  const linkWithPaymentBenefits = formattedPaymentBenefitsIds
    ? `${linkWithTOFilters}&${formattedPaymentBenefitsIds}`
    : linkWithTOFilters;

  const linkWithInstantConfirm = instantConfirm
    ? `${linkWithPaymentBenefits}&${CONFIRMABILITY_PARAM_KEY}[]=1&`
    : `${linkWithPaymentBenefits}`;

  const isWebview = yield select(getIsWebview);
  const partnerId = !isSSR ? window?.PARTNER?.id : null;
  const offerLink =
    operatorsIds.length || paymentBenefitsIds.length || instantConfirm === true
      ? linkWithInstantConfirm
      : link;

  const isGHCPartner = partnerId === 1186;

  // добавляем параметр для аналитики соседних перелетов
  const linkWithSourceParam = `${offerLink}&source=web`;

  maybeOpenInNewTab(linkWithSourceParam, isWebview || isGHCPartner);
}

export default function* hotelOfferWatcher() {
  yield all([takeLatest(openOfferAction.type, handleOfferClicked)]);
}
